<template>
  <div class="container" v-change-title="($route.meta.title = activityTitle)">
    <div class="head" :style="{ backgroundImage: 'url(' + bgIndex + ')' }">
      <van-image v-if="teacherImg" class="teacher" fit="cover" :src="teacherImg" alt> </van-image>
    </div>
    <div class="main">
      <div class="main-container">
        <p class="title">{{ activityTitle }}</p>
        <p class="des">{{ entrance_title }}</p>
        <ul class="caption-list">
          <li class="item">{{ classOutlineFormt['task_num'] }}节课</li>
        </ul>
      </div>
      <div class="main-full-container">
        <div ref="tab" class="tab">
          <van-sticky @scroll="tabScroll">
            <ul class="tab-nav">
              <template v-for="(item, index) in tabList">
                <li
                  v-if="
                    (item.type == 1 && (high_lights.length > 0 || suitable_for.length > 0)) ||
                      (item.type == 2 && classOutlineFormt['days'] > 1) ||
                      (item.type == 3 && teacherId)
                  "
                  :key="index"
                  v-anchor="{ target: '#section_' + item.type }"
                  :class="{ active: tabList_active == item.type }"
                  @click="handleClick_tab(item.type)"
                >
                  <a href="javascript:void(0);">{{ item.name }}</a>
                  <span></span>
                </li>
              </template>
            </ul>
          </van-sticky>
        </div>
      </div>
      <div class="main-container">
        <div ref="sectionConent" class="tab-content">
          <section v-for="(item, index) in tabList" :key="index" :id="'section_' + item.type">
            <section-jianjie-liangdian
              :list="high_lights"
              v-if="item.type == 1 && high_lights.length > 0"
            ></section-jianjie-liangdian>
            <section-jianjie-renqun
              :list="suitable_for"
              v-if="item.type == 1 && suitable_for.length > 0"
            ></section-jianjie-renqun>
            <section-jianjie-dagang
              :list="classOutlineFormt"
              v-if="item.type == 2 && classOutlineFormt['days'] > 1"
            ></section-jianjie-dagang>
            <section-jianjie-zhujiang
              :name="teacherName"
              :type="teacherType"
              :introduce="teacherIntroduce"
              :teacherImg="teacherImg"
              v-if="item.type == 3 && teacherId"
            ></section-jianjie-zhujiang>
          </section>
        </div>
      </div>
    </div>
    <com-footer
      :current_price="current_price"
      :original_price="original_price"
      :hasGet="hasGet"
      @handleClick_freeGet="freeGet"
      @handleClick_goClass="goClass"
    ></com-footer>
  </div>
</template>
<script>
import sectionJianjieLiangdian from './components/section_jianjie_liangdian/index';
import sectionJianjieRenqun from './components/section_jianjie_renqun/index';
import sectionJianjieDagang from './components/section_jianjie_dagang/index';
import sectionJianjieZhujiang from './components/section_jianjie_zhujiang/index';
import comFooter from './components/footer/index';
import { debounce, eachRight } from 'lodash-es';
import { Dialog } from 'vant';
import api from '../_api';
//import kmfSensors from "kmf-sensors";
import { isIos, isAndroid, delObj, setCookies, getCookies } from '@/utils/utils.js';

export default {
  components: {
    sectionJianjieLiangdian,
    sectionJianjieRenqun,
    sectionJianjieDagang,
    sectionJianjieZhujiang,
    comFooter
  },
  computed: {
    //活动标题
    activityTitle() {
      if (this.checkInfo()) {
        return this.activityInfo.list[0].title;
      } else {
        return '';
      }
    },
    //活动描述
    entrance_title() {
      if (this.checkInfo()) {
        return this.activityInfo.list[0].entrance_title;
      } else {
        return '';
      }
    },
    //老师姓名
    teacherName() {
      if (this.checkInfo()) {
        let _teacher = this.activityInfo.teachers[this.activityInfo.list[0].teacher_id];
        return _teacher ? _teacher['name'] : '未知';
      } else {
        return '未知';
      }
    },
    //课程亮点
    high_lights() {
      if (this.checkInfo()) {
        return [...this.activityInfo.list[0].introduction.high_lights];
      } else {
        return [];
      }
    },
    //适合人群
    suitable_for() {
      if (this.checkInfo()) {
        return [...this.activityInfo.list[0].introduction.suitable_for];
      } else {
        return [];
      }
    },
    //课程大纲
    classOutlineFormt() {
      this.classOutline.sort((a, b) => {
        return a.day < b.day;
      });
      let obj = {
        day: {},
        days: 0,
        task_num: 0
      };
      this.classOutline.forEach((item, index) => {
        if (obj['day'][item.day]) {
          obj['day'][item.day].push(item);
        } else {
          obj['days'] += 1;
          obj['day'][item.day] = [];
          obj['day'][item.day].push(item);
        }
        obj['task_num'] += 1;
      });
      return obj;
    },
    //老师类型
    teacherType() {
      if (this.checkInfo()) {
        let _teacher = this.activityInfo.teachers[this.activityInfo.list[0].teacher_id];
        let site_name = this.activityInfo.list[0].site_name;
        return _teacher ? (_teacher['subject_names'][site_name] ? _teacher['subject_names'][site_name][0] : '') : '';
      } else {
        return '';
      }
    },
    //老师介绍
    teacherIntroduce() {
      if (this.checkInfo()) {
        let _teacher = this.activityInfo.teachers[this.activityInfo.list[0].teacher_id];
        return _teacher ? _teacher['introduce'] : '暂无';
      } else {
        return '暂无';
      }
    },
    //老师ID
    teacherId() {
      if (this.checkInfo()) {
        let _teacher = this.activityInfo.teachers[this.activityInfo.list[0].teacher_id];
        return _teacher ? true : false;
      } else {
        return false;
      }
    },
    //老师头图
    teacherImg() {
      if (this.checkInfo()) {
        if (Object.prototype.toString.call(this.activityInfo.teachers) == '[object Array]') {
          return '';
        } else if (Object.prototype.toString.call(this.activityInfo.teachers) == '[object Object]') {
          let _teacher = this.activityInfo.teachers[this.activityInfo.list[0].teacher_id];
          return _teacher['adv_pic'] || '';
        } else {
          return '';
        }
      } else {
        return '';
      }
    },
    //当前价格
    current_price() {
      if (this.checkInfo()) {
        return this.activityInfo.list[0].current_price || 0;
      } else {
        return 0;
      }
    },
    //原价
    original_price() {
      if (this.checkInfo()) {
        return this.activityInfo.list[0].original_price || 0;
      } else {
        return 0;
      }
    },
    //背景图片
    bgIndex() {
      return require('@/assets/img/itles-webapp-videoClass/headbg-' + (this.query.activity_id % 5) + '.png');
    }
  },
  data: () => {
    return {
      tabList_active: 1,
      tabList: [{ name: '课程简介', type: 1 }, { name: '课程大纲', type: 2 }, { name: '主讲老师', type: 3 }],
      activityInfo: null,
      classOutline: [], //课程大纲
      _scrollInit: null,
      hasGet: false, //是否已经获取视频课程
      query: {
        authorization: 0,
        activity_id: '',
        weixin: '',
        idea_id: '',
        idea_time: '',
        cc_pid: '',
        task_id: '',
        cc_group_id: ''
      }
    };
  },
  methods: {
    async kmfSensorsInit() {
      let pid;
      if (!this.query.authorization) {
        pid = 0;
      } else {
        let result = await this.getPassportId();
        if (result.status == 200) {
          let { id } = result.result;
          pid = id;
        } else {
          pid = 0;
        }
      }
      this.$kmfSensors.init({
        pid: pid,
        params: {
          project: 'ielts',
          platform: isIos() ? 'ios' : 'android',
          product_line: this.query.product_line
        }
      });
    },
    tabScroll(even) {
      // this.isFixed=even.isFixed;
    },
    getPassportId() {
      return this.$http.get(api.getPassport, {
        headers: {
          'K-Idfa-Imei': '',
          /* 'K-Product-Line': '',
          'K-Platform': '' */
        }
      });
    },
    //免费获取
    freeGet() {
      if (!this.query.authorization) {
        this.$toast({
          message: '请先登录',
          onClose: () => {
            this.goLogin();
          }
        });
        return;
      }
      if (this.activityInfo['list'][0]['shop_tag'] == 2) {
        this.$toast('活动配置无效，无法报名!');
        return;
      }
      if (window.kmfSensors) {
        if (this.query.idea_id) {
          window.kmfSensors.track('signUpClickEvent', {
            activity_id: this.query.activity_id,
            idea_id: this.query.idea_id,
            product: 'ielts',
            platform: isIos() ? 'ios' : 'android',
            product_line: this.query.product_line
          });
        } else {
          window.kmfSensors.track('signUpTEClickEvent', {
            activity_id: this.query.activity_id,
            product: 'ielts',
            platform: isIos() ? 'ios' : 'android',
            product_line: this.query.product_line
          });
        }
      }
      let data = Object.assign({}, this.query);
      data = delObj(Object.assign({}, data), ['product_line', 'authorization']);
      this.$http.post(api.apply, data).then(res => {
        if (res.result.error_code == 200) {
          if (this.activityInfo['list'][0]['shop_tag'] == 0) {
            this.hasGet = true;
            this.$toast.success('报名成功');
          } else if (this.activityInfo['list'][0]['shop_tag'] == 1) {
            let originUrl = window.location.href;
            setCookies('common-payBridge', originUrl);
            let goodsArr = [];
            goodsArr.push({
              number: 1,
              goods_id: this.activityInfo['list'][0].goods_id
            });
            window.location.href = `${process.env.VUE_APP_PRFIEX}shop.kmf.com/shop/#/buy?items=${JSON.stringify(
              goodsArr
            )}`;
          }
        } else {
          this.$toast.fail(res.result.error_msg);
        }
      });
    },
    //进入课程
    goClass() {
      if (isIos()) {
        window.webkit.messageHandlers.nativeGoClass.postMessage(null);
      }
      if (isAndroid()) {
        window.app.nativeGoClass();
      }
    },
    //去登陆
    goLogin() {
      if (isIos()) {
        window.webkit.messageHandlers.nativeLogin.postMessage(null);
      }
      if (isAndroid()) {
        window.app.nativeLogin();
      }
    },
    checkInfo() {
      return this.activityInfo && this.activityInfo.list.length > 0 ? true : false;
    },
    handleClick_tab(type) {
      this.unbindScroll();
      this.tabList_active = type;
      setTimeout(() => {
        this.bindScroll();
      }, 400);
    },
    scrollInit() {
      let scroll = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
      let sectionList = this.$refs.sectionConent.children;
      let _index = 0;
      eachRight(sectionList, (item, index) => {
        if (scroll >= item.offsetTop) {
          _index = index;
          return false;
        }
      });
      this.tabList_active = this.tabList[_index].type;
    },

    bindScroll() {
      window.addEventListener('scroll', this._scrollInit, false);
    },
    unbindScroll() {
      window.removeEventListener('scroll', this._scrollInit, false);
    },
    getActivity_1() {
      this.$http
        .get(api.getHdList, {
          params: {
            activity_ids: this.query.activity_id
          }
        })
        .then(res => {
          if (res.status == 200) {
            if (res.result.list.length == 0) {
              Dialog.alert({
                title: '提示!',
                message: '活动已经结束'
              }).then(() => {
                // on close
              });
              return;
            } else {
              this.activityInfo = res.result;
            }
          }
        });
    },
    getActivity_2() {
      this.$http
        .get(api.getHdTasks, {
          params: {
            activity_ids: this.query.activity_id
          },
          headers: {
            'K-Version': 'v2'
          }
        })
        .then(res => {
          if (res.status == 200) {
            this.classOutline = res.result.list[this.query.activity_id];
          }
        });
    },
    getHasGet(cb) {
      this.$http.get(`${api.getHasGet}/${this.query.activity_id}`).then(res => {
        if (res.result.enroll.apply_status == 1 || res.apply_status == 2) {
          this.hasGet = true;
        } else {
          this.hasGet = false;
        }
        if (cb) cb();
      });
    }
  },
  mounted() {
    this._scrollInit = debounce(this.scrollInit, 300, { leading: true });
    this.bindScroll();
  },
  destroyed() {
    this.unbindScroll();
  },
  created() {
    this.query = Object.assign({}, this.query, this.$route.query);
    if (this.query.authorization) {
      setCookies('authkey', this.query.authorization);
    }
    this.kmfSensorsInit();
    this.getActivity_1();
    this.getActivity_2();
    if (getCookies('authkey')) {
      this.getHasGet();
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  background-color: #fff;
  .head {
    height: tovw(542);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    .teacher {
      display: block;
      width: tovw(392);
      height: tovw(360);
      margin: 0 auto;
      padding-top: tovw(102);
      overflow: hidden;
    }
  }
  .main {
    background-color: #fff;
    border-top-left-radius: tovw(64);
    border-top-right-radius: tovw(64);
    padding-bottom: tovw(220);
    margin-top: tovw(-80);
    .main-container {
      padding: 0 tovw(40);
      section {
        padding-top: tovw(50);
      }
    }
    .main-full-container {
      padding: 0;
    }
    .title {
      font-size: tovw(44);
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.8);
      line-height: tovw(64);
      padding-top: tovw(56);
      padding-bottom: tovw(20);
    }
    .des {
      font-size: tovw(28);
      font-family: PingFangSC-Light, PingFang SC;
      font-weight: 300;
      color: rgba(0, 0, 0, 0.8);
      line-height: tovw(48);
      padding-bottom: tovw(16);
    }
    .caption-list {
      .item {
        display: inline-block;
        width: tovw(80);
        height: tovw(40);
        background: rgba(102, 168, 29, 0.04);
        border-radius: tovw(8);
        border: 1px solid rgba(102, 168, 29, 0.2);
        font-size: tovw(24);
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(102, 168, 29, 1);
        line-height: tovw(40);
        text-align: center;
        margin: 0 tovw(20) tovw(20) 0;
      }
    }
    .tab {
      border-bottom: 1px solid rgba(221, 221, 221, 0.4);
      .tab-nav {
        background-color: #fff;
        li {
          position: relative;
          display: inline-block;
          height: tovw(88);
          width: 33.33%;
          text-align: center;
          line-height: tovw(88);
          a {
            display: block;
            width: 100%;
            height: 100%;
            font-size: tovw(34);
            font-weight: 400;
            color: #a5a5a5;
          }
          span {
            display: none;
            position: absolute;
            width: tovw(48);
            height: tovw(6);
            background: #5f5ddc;
            border-radius: 3px;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
          }
        }
        li.active {
          a {
            color: #5f5ddc;
            font-weight: 600;
          }
          span {
            display: block;
          }
        }
      }
    }
  }
}
</style>
